"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAsyncCallbacks = void 0;
class SimpleAsyncCallbacks {
    constructor() {
        this.onConnectCallback = null;
        this.onDisconnectCallback = null;
        this.onConnectionErrorCallback = null;
        this.onDataReceiveCallback = null;
    }
    notifyConnect() {
        var _a;
        (_a = this.onConnectCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    notifyDisconnect() {
        var _a;
        (_a = this.onDisconnectCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    notifyDataReceive(data) {
        var _a;
        (_a = this.onDataReceiveCallback) === null || _a === void 0 ? void 0 : _a.call(this, data);
    }
    notifyConnectionError() {
        var _a;
        (_a = this.onConnectionErrorCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    onConnect(callback) {
        this.onConnectCallback = callback;
    }
    onDisconnect(callback) {
        this.onDisconnectCallback = callback;
    }
    onDataReceive(callback) {
        this.onDataReceiveCallback = callback;
    }
    onConnectionError(callback) {
        this.onConnectionErrorCallback = callback;
    }
}
exports.SimpleAsyncCallbacks = SimpleAsyncCallbacks;
//# sourceMappingURL=index.js.map